export default "__VITE_ASSET__CIIVBLvu__"